export function formatOfferDate(dateString: string): string {
	if (!dateString) return ""

	const [year, month, day] = dateString.split("-").map(Number)

	return new Date(Date.UTC(year, month - 1, day)).toLocaleDateString(undefined, {timeZone: "UTC"})
}
